import { Investment } from "@rentablo/api/apiv1";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";

export const getDisplayedInvestment = (row: Investment, isGlobal: boolean) => ({
  purchaseValue: isGlobal ? row.purchaseValueAC : row.purchaseValue,
  purchasePrice: isGlobal ? row.purchasePriceAC : row.purchasePrice,
  currentMarketValue: isGlobal
    ? row.currentMarketValueAC
    : row.currentMarketValue,
  returnOnInvestmentInPercent: isGlobal
    ? row.returnOnInvestmentInPercentAC
    : row.returnOnInvestmentInPercent,
  receivedTotalDividend: isGlobal
    ? row.receivedTotalDividendAC
    : row.receivedTotalDividend,
  currentMarketValueWithDividend: isGlobal
    ? row.currentMarketValueWithDividendAC
    : row.currentMarketValueWithDividend,
  returnOnInvestmentWithDividendInPercent: isGlobal
    ? row.returnOnInvestmentWithDividendInPercentAC
    : row.returnOnInvestmentWithDividendInPercent,
});

export const useDisplayedInvestment = (row: Investment) => {
  const { selectedCurrencyView, getDisplayCurrency } = useCurrencyDisplay();
  return {
    currency: getDisplayCurrency(row.currency),
    ...getDisplayedInvestment(row, selectedCurrencyView === "global"),
  };
};
